import { BookingDuration } from 'core/domain/bookingsAndCommonAreas/models/commonAreaEntityModels';

export const DEFAULT_MAXIMUM_TIME_AVAILABILITY_PERIOD = 'month';
export const DEFAULT_MAXIMUM_TIME_AVAILABILITY_VALUE = '6';
export const DEFAULT_MAXIMUM_BOOKINGS_BY_USER = 1000;
export const DEFAULT_TIME_AVAILABILITY = [null];

export const BOOKING_DURATION_OPTIONS: { id: BookingDuration; name: string }[] = [
  { id: 30, name: '30 min' },
  { id: 60, name: '60 min' },
  { id: 90, name: '90 min' },
  { id: 120, name: '2 h' },
  { id: 180, name: '3 h' },
  { id: 240, name: '4 h' },
  { id: 300, name: '5 h' },
  { id: 360, name: '6 h' },
  { id: 420, name: '7 h' },
  { id: 480, name: '8 h' },
  { id: 540, name: '9 h' },
  { id: 600, name: '10 h' },
  { id: 660, name: '11 h' },
  { id: 720, name: '12 h' },
];
